var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu"},_vm._l((_vm.links),function(link){return _c('router-link',{key:link.route,attrs:{"to":link.route}},[_c('v-btn',{staticClass:"button",attrs:{"tile":"","elevation":"0"}},[_vm._v(_vm._s(link.label))])],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }